export default class PageTab {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    this.tabs = document.querySelectorAll('.js-page-tab');
    if (this.tabs.length === 0) return;

    this.addClickEvents();
    this.checkHashOnLoad();
  }

  addClickEvents() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleClick.bind(this));
    });
  }

  handleClick(eventOrElement) {
    const clickedTab = eventOrElement.currentTarget || eventOrElement;
    const targetTabKey = clickedTab.dataset.tab;
    if (!targetTabKey) return;

    // すべての .js-page-tab からクラスを削除
    document.querySelectorAll('.js-page-tab').forEach(tab => {
      tab.classList.remove('is-page-tab-active');
    });

    // すべての data-tab 要素からクラスを削除（同じ data-tab のみを残す）
    document.querySelectorAll('[data-tab]').forEach(el => {
      if (el.dataset.tab !== targetTabKey) {
        el.classList.remove('is-page-tab-active');
      }
    });

    // 対象にクラスを追加
    document.querySelectorAll(`[data-tab="${targetTabKey}"]`).forEach(el => {
      el.classList.add('is-page-tab-active');
    });
  }

  checkHashOnLoad() {
    const hash = window.location.hash.replace('#', '');
    if (!hash) return;

    // hashと一致するdata-tabを持つタブ要素があればクリック処理
    const targetTab = Array.from(this.tabs).find(tab => tab.dataset.tab === hash);
    if (targetTab) {
      this.handleClick(targetTab);
    }
  }
}
